import { ApolloProvider } from '@apollo/client'

import client from 'services/apolloClient'

const ApolloClientProvider = ({ children }) => (
  <ApolloProvider client={client}>{children}</ApolloProvider>
)

export default ApolloClientProvider
